<template>
  <v-sheet rounded class="pa-4" color="secondary">
    <span>{{block.className}}</span> <small>クラス</small><br>
    <small>基本料金:</small> <span>{{block.chargeText}}</span>
  </v-sheet>
</template>

<script>
export default {
  name: 'CBlockHeader',
  props: {
    block: {
      type: Object,
      required: true
    }
  }
}
</script>
